export default {
    zh: {
        dcNo: '评分模块',
        dcName: '评分大类',
        dcStatus: '评分小类',
        specUpload: '大类分值',
        rfpInitiate: '评分标准说明',
        createTemp: '生成模板',
        trak: '评分任务编号',
        ssrNo: 'SSR编号',
        category1: '品类一级',
        category2: '品类二级',
        score: '分数',
        ScoreTtems: '评分项分值',
        submitDate: '评分提交日期',
        pushDate: '发布日期',
        endDate: '评分完成日期',
        supplierType: '供应商类型',
        pushScore: '发布评分',
        bigName: '评分大类名称',
        finishDate: '评分截止日期',
        needSupplierSelfMark: '是否发起供应商自评',
        rfpNo: 'RFP编号',
        auditRemark: '复核意见',
        createDate: '评分创建日期',
        day: '倒计时：',
        attachmentUpload: '附件上传',
        SaveOrUpdateMark: '提交',
        ConfirmRelease: '确认并发布',
        ApprovalComments: '审批意见',
        canAudit: '审批',
        DownloadExcel: 'Excel下载',
        ChartDownload: '图表下载',
        Cancel: '取 消',
        determine: '确 定',
        currentRound: '轮次数',
        ssrcurrentRound: 'SSR/RFP轮次',
        supplierCode: '供应商编号',
        supplierNameShort: '供应商简称',
        statusI18n: '状态',
        remark: '评分描述',
        smallScore: '小类分值',
        creator: '发起人',
        invitationCode: '供应商编号',
        supplierName: '供应商名称',
        Period: '创建日期',
        savedData: '请操作要保存的数据！',
        totalScore: '总分值',
        NoPlaceHolder: '支持多个供应商，请用英文逗号隔开',

    },
    en: {}
}